module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-solid-ce2c9c77504bc866a42d97efe62846ad.svg";